// fittingsCatalog.js — дефолтные цены на фитинги
// Ключи соответствуют ключам из fittingsData.js

const DEFAULT_FITTING_PRICES = {
  // Ниппели (минимальная цена + доп. расчет при увеличении длины)
  // Формула: если длина <= baseLength, то minPrice
  // Если длина > baseLength, то: minPrice + (pipePricePerMeter * (length - baseLength) / 1000) + (weldCost * weldCoefficient)
  'Nippel_1.4': { 
    pricingType: 'nippel_formula', 
    minPrice: 80, 
    baseLength: 30, 
    pipeDiameter: 13.7, 
    pipeThickness: 'x2',
    pipeCoating: 'Матовый', // 13.7|x2|Матовый: 300₽/м
    weldCost: 10, 
    weldCoefficient: 3 
  },
  'Nippel_3.8': { 
    pricingType: 'nippel_formula', 
    minPrice: 90, 
    baseLength: 30, 
    pipeDiameter: 17.2, 
    pipeThickness: 'x2',
    pipeCoating: 'Матовый', // 17.2|x2|Матовый: 350₽/м
    weldCost: 10, 
    weldCoefficient: 3 
  },
  'Nippel_1.2': { 
    pricingType: 'nippel_formula', 
    minPrice: 110, 
    baseLength: 35, 
    pipeDiameter: 21.3, 
    pipeThickness: 'x3',
    pipeCoating: 'Матовый', // 21.3|x3|Матовый: 585₽/м
    weldCost: 13, 
    weldCoefficient: 3 
  },
  'Nippel_3.4': { 
    pricingType: 'nippel_formula', 
    minPrice: 135, 
    baseLength: 40, 
    pipeDiameter: 26.9, 
    pipeThickness: 'x3',
    pipeCoating: 'Матовый', // 26.9|x3|Матовый: 810₽/м
    weldCost: 14, 
    weldCoefficient: 3 
  },
  'Nippel_1': { 
    pricingType: 'nippel_formula', 
    minPrice: 170, 
    baseLength: 40, 
    pipeDiameter: 33.7, 
    pipeThickness: 'x3',
    pipeCoating: 'Зеркало', // 33.7|x3|Зеркало: 1290₽/м (только Зеркало!)
    weldCost: 15, 
    weldCoefficient: 3 
  },
  'Nippel_1_1.4': { 
    pricingType: 'nippel_formula', 
    minPrice: 225, 
    baseLength: 50, 
    pipeDiameter: 42.4, 
    pipeThickness: 'x3',
    pipeCoating: 'Матовый', // 42.4|x3|Матовый: 1270₽/м
    weldCost: 19.4, 
    weldCoefficient: 3 
  },
  'Nippel_1_1.2': { 
    pricingType: 'nippel_formula', 
    minPrice: 305, 
    baseLength: 50, 
    pipeDiameter: 48.3, 
    pipeThickness: 'x3',
    pipeCoating: 'Матовый', // 48.3|x3|Матовый: 1460₽/м
    weldCost: 25, 
    weldCoefficient: 3 
  },
  'Nippel_2': { 
    pricingType: 'nippel_formula', 
    minPrice: 445, 
    baseLength: 55, 
    pipeDiameter: 60.3, 
    pipeThickness: 'x3',
    pipeCoating: 'Матовый', // 60.3|x3|Матовый: 1900₽/м
    weldCost: 27.6, 
    weldCoefficient: 3 
  },
  'Nippel_2_1/2': { 
    pricingType: 'nippel_formula', 
    minPrice: 685, 
    baseLength: 60, 
    pipeDiameter: 76.1, 
    pipeThickness: 'x3',
    pipeCoating: 'Матовый', // 76.1|x3|Матовый: 2340₽/м
    weldCost: 34.2, 
    weldCoefficient: 3 
  },
  'Nippel_3': { 
    pricingType: 'nippel_formula', 
    minPrice: 925, 
    baseLength: 68, 
    pipeDiameter: 88.9, 
    pipeThickness: 'x3',
    pipeCoating: 'Матовый', // 88.9|x3|Матовый: 2850₽/м
    weldCost: 42.3, 
    weldCoefficient: 3 
  },
  'Nippel_4': { 
    pricingType: 'nippel_formula', 
    minPrice: 1250, 
    baseLength: 76, 
    pipeDiameter: 114.3, 
    pipeThickness: 'x3',
    pipeCoating: 'Матовый', // 114.3|x3|Матовый: 3790₽/м
    weldCost: 43.8, 
    weldCoefficient: 3 
  },

  // Муфты (минимальная цена + доп. расчет при увеличении длины, толщина стенки 3мм, сталь AISI304)
  // Формула как у ниппелей: если длина <= baseLength, то minPrice
  // Если длина > baseLength, то: minPrice + (pipePricePerMeter * (length - baseLength) / 1000) + (weldCost * weldCoefficient)
  // Используем ближайшие трубы В БОЛЬШУЮ СТОРОНУ с толщиной x3
  'Mufta_1.4': { 
    pricingType: 'nippel_formula', 
    minPrice: 98, 
    baseLength: 10, // из fittingsData: length: 10
    pipeDiameter: 21.3, // муфта 17.4 → ближайшая труба в большую сторону
    pipeThickness: 'x3',
    pipeCoating: 'Матовый', // 21.3|x3|Матовый: 585₽/м
    weldCost: 10, 
    weldCoefficient: 3 
  },
  'Mufta_3.8': { 
    pricingType: 'nippel_formula', 
    minPrice: 163, 
    baseLength: 10, // из fittingsData: length: 10
    pipeDiameter: 21.3, // муфта 20.8 → ближайшая труба в большую сторону
    pipeThickness: 'x3',
    pipeCoating: 'Матовый', // 21.3|x3|Матовый: 585₽/м
    weldCost: 12, 
    weldCoefficient: 3 
  },
  'Mufta_1.2': { 
    pricingType: 'nippel_formula', 
    minPrice: 102, 
    baseLength: 18, // из fittingsData: length: 18
    pipeDiameter: 26.9, // муфта 24.5 → ближайшая труба в большую сторону
    pipeThickness: 'x3',
    pipeCoating: 'Матовый', // 26.9|x3|Матовый: 810₽/м
    weldCost: 14, 
    weldCoefficient: 3 
  },
  'Mufta_3.4': { 
    pricingType: 'nippel_formula', 
    minPrice: 162, 
    baseLength: 34.5, // из fittingsData: length: 34.5
    pipeDiameter: 33.7, // метр трубы 1" — прайс getDn25CatalogPipeSpec() (33,7×3 Зеркало)
    pipeThickness: 'x3',
    pipeCoating: 'Матовый',
    weldCost: 15, 
    weldCoefficient: 3 
  },
  'Mufta_1': { 
    pricingType: 'nippel_formula', 
    minPrice: 300, 
    baseLength: 42, // из fittingsData: length: 42
    pipeDiameter: 42.4, // муфта 38 → ближайшая труба в большую сторону
    pipeThickness: 'x3',
    pipeCoating: 'Матовый', // 42.4|x3|Матовый: 1270₽/м
    weldCost: 15, 
    weldCoefficient: 3 
  },
  'Mufta_1_1.4': { 
    pricingType: 'nippel_formula', 
    minPrice: 378, 
    baseLength: 46, // из fittingsData: length: 46
    pipeDiameter: 48.3, // муфта 48 → ближайшая труба в большую сторону
    pipeThickness: 'x3',
    pipeCoating: 'Матовый', // 48.3|x3|Матовый: 1460₽/м
    weldCost: 22, 
    weldCoefficient: 3 
  },
  'Mufta_1_1.2': { 
    pricingType: 'nippel_formula', 
    minPrice: 520, 
    baseLength: 46, // из fittingsData: length: 46
    pipeDiameter: 60.3, // муфта 53.9 → ближайшая труба x3 в большую сторону (54 нет x3)
    pipeThickness: 'x3',
    pipeCoating: 'Матовый', // 60.3|x3|Матовый: 1900₽/м
    weldCost: 25, 
    weldCoefficient: 3 
  },
  'Mufta_2': { 
    pricingType: 'nippel_formula', 
    minPrice: 624, 
    baseLength: 54, // из fittingsData: length: 54
    pipeDiameter: 76.1, // муфта 66 → ближайшая труба в большую сторону
    pipeThickness: 'x3',
    pipeCoating: 'Матовый', // 76.1|x3|Матовый: 2340₽/м
    weldCost: 28, 
    weldCoefficient: 3 
  },

  // Заглушки прямые (за шт)
  'Zaglushka_PR_42.4': { pricingType: 'per_piece', price: 24 },
  'Zaglushka_PR_48.3': { pricingType: 'per_piece', price: 29 },
  'Zaglushka_PR_60.3': { pricingType: 'per_piece', price: 41 },
  'Zaglushka_PR_76.1': { pricingType: 'per_piece', price: 60 },
  'Zaglushka_PR_88.9': { pricingType: 'per_piece', price: 76 },
  'Zaglushka_PR_101.6': { pricingType: 'per_piece', price: 123 },
  'Zaglushka_PR_20х20': { pricingType: 'per_piece', price: 32 },
  'Zaglushka_PR_25х25': { pricingType: 'per_piece', price: 34 },
  'Zaglushka_PR_40х40': { pricingType: 'per_piece', price: 40 },
  'Zaglushka_PR_50х50': { pricingType: 'per_piece', price: 46 },
  'Zaglushka_PR_60х60': { pricingType: 'per_piece', price: 52 },
  'Zaglushka_PR_80х80': { pricingType: 'per_piece', price: 70 },
  'Zaglushka_PR_100х100': { pricingType: 'per_piece', price: 135 },
  'Zaglushka_PR_150х150': { pricingType: 'per_piece', price: 224 },

  // Заглушки эллиптические (за шт)
  'Zaglushka_EL_42.4': { pricingType: 'per_piece', price: 125 },
  'Zaglushka_EL_48.3': { pricingType: 'per_piece', price: 135 },
  'Zaglushka_EL_60.3': { pricingType: 'per_piece', price: 170 },
  'Zaglushka_EL_76.1': { pricingType: 'per_piece', price: 260 },
  'Zaglushka_EL_88.9': { pricingType: 'per_piece', price: 315 },
  'Zaglushka_EL_101.6': { pricingType: 'per_piece', price: 350 },
  'Zaglushka_EL_114.3': { pricingType: 'per_piece', price: 390 },
  'Zaglushka_EL_129': { pricingType: 'per_piece', price: 305 },
  'Zaglushka_EL_139.7': { pricingType: 'per_piece', price: 650 },
  'Zaglushka_EL_159': { pricingType: 'per_piece', price: 762 },
  'Zaglushka_EL_168.3': { pricingType: 'per_piece', price: 717 },
  'Zaglushka_EL_219.1': { pricingType: 'per_piece', price: 1205 },
  'Zaglushka_EL_273': { pricingType: 'per_piece', price: 2150 },
  'Zaglushka_EL_323.9': { pricingType: 'per_piece', price: 3000 },
  'Zaglushka_EL_355.6': { pricingType: 'per_piece', price: 3900 },
  'Zaglushka_EL_406.4': { pricingType: 'per_piece', price: 7200 },
  'Zaglushka_EL_508': { pricingType: 'per_piece', price: 15000 },
  'Zaglushka_EL_609.6': { pricingType: 'per_piece', price: 15000 },

  // Переходы концентрические (за шт)
  'Perehod_Konc_48.3х42.4': { pricingType: 'per_piece', price: 300 },
  'Perehod_Konc_60.3х48.3': { pricingType: 'per_piece', price: 308 },
  'Perehod_Konc_76.1х60.3': { pricingType: 'per_piece', price: 310 },
  'Perehod_Konc_88.9х76.1': { pricingType: 'per_piece', price: 325 },
  'Perehod_Konc_114.3х88.9': { pricingType: 'per_piece', price: 350 },

  // Фланцы свободные оцинкованные (за шт)
  'Flanec_25_galv': { pricingType: 'per_piece', price: 332 },
  'Flanec_32_galv': { pricingType: 'per_piece', price: 392 },
  'Flanec_40_galv': { pricingType: 'per_piece', price: 480 },
  'Flanec_50_galv': { pricingType: 'per_piece', price: 511 },
  'Flanec_65_galv': { pricingType: 'per_piece', price: 627 },
  'Flanec_80_galv': { pricingType: 'per_piece', price: 841 },
  'Flanec_100_galv': { pricingType: 'per_piece', price: 1100 },
  'Flanec_125_galv': { pricingType: 'per_piece', price: 1230 },
  'Flanec_150_galv': { pricingType: 'per_piece', price: 1830 },
  'Flanec_200_galv': { pricingType: 'per_piece', price: 3500 },
  'Flanec_250_galv': { pricingType: 'per_piece', price: 3800 },
  'Flanec_300_galv': { pricingType: 'per_piece', price: 0 },
  'Flanec_350_galv': { pricingType: 'per_piece', price: 0 },

  // Фланцы свободные нержавеющие (за шт)
  'Flanec_25_ss': { pricingType: 'per_piece', price: 990 },
  'Flanec_32_ss': { pricingType: 'per_piece', price: 1050 },
  'Flanec_40_ss': { pricingType: 'per_piece', price: 1391 },
  'Flanec_50_ss': { pricingType: 'per_piece', price: 1683 },
  'Flanec_65_ss': { pricingType: 'per_piece', price: 2048 },
  'Flanec_80_ss': { pricingType: 'per_piece', price: 2489 },
  'Flanec_100_ss': { pricingType: 'per_piece', price: 2853 },
  'Flanec_125_ss': { pricingType: 'per_piece', price: 4700 },
  'Flanec_150_ss': { pricingType: 'per_piece', price: 0 },
  'Flanec_200_ss': { pricingType: 'per_piece', price: 0 },
  'Flanec_250_ss': { pricingType: 'per_piece', price: 0 },
  'Flanec_300_ss': { pricingType: 'per_piece', price: 0 },
  'Flanec_350_ss': { pricingType: 'per_piece', price: 0 },


  // Фланцы штампованные нержавеющие (за шт)
  'Flanec_25_ss_stamped': { pricingType: 'per_piece', price: 760 },
  'Flanec_32_ss_stamped': { pricingType: 'per_piece', price: 820 },
  'Flanec_40_ss_stamped': { pricingType: 'per_piece', price: 980 },
  'Flanec_50_ss_stamped': { pricingType: 'per_piece', price: 1018 },
  'Flanec_65_ss_stamped': { pricingType: 'per_piece', price: 1140 },
  'Flanec_80_ss_stamped': { pricingType: 'per_piece', price: 1208 },
  'Flanec_100_ss_stamped': { pricingType: 'per_piece', price: 1710 },
  'Flanec_125_ss_stamped': { pricingType: 'per_piece', price: 2600 },
  'Flanec_150_ss_stamped': { pricingType: 'per_piece', price: 3600 },
  'Flanec_200_ss_stamped': { pricingType: 'per_piece', price: 4810 },

  // Фланцы приварные нержавеющие (за шт)
  'Flanec_25_welded': { pricingType: 'per_piece', price: 840 },
  'Flanec_32_welded': { pricingType: 'per_piece', price: 900 },
  'Flanec_40_welded': { pricingType: 'per_piece', price: 1000 },
  'Flanec_50_welded': { pricingType: 'per_piece', price: 1250 },
  'Flanec_65_welded': { pricingType: 'per_piece', price: 1515 },
  'Flanec_80_welded': { pricingType: 'per_piece', price: 1950 },
  'Flanec_100_welded': { pricingType: 'per_piece', price: 2500 },
  'Flanec_125_welded': { pricingType: 'per_piece', price: 3000 },
  'Flanec_150_welded': { pricingType: 'per_piece', price: 3800 },
  'Flanec_200_welded': { pricingType: 'per_piece', price: 4810 },
  'Flanec_250_welded': { pricingType: 'per_piece', price: 6860 },
  'Flanec_300_welded': { pricingType: 'per_piece', price: 7560 },
  'Flanec_350_welded': { pricingType: 'per_piece', price: 10260 },

  // Бортшайбы (за шт)
  'Bortshaiba_25': { pricingType: 'per_piece', price: 79 },
  'Bortshaiba_32': { pricingType: 'per_piece', price: 105 },
  'Bortshaiba_40': { pricingType: 'per_piece', price: 155 },
  'Bortshaiba_50': { pricingType: 'per_piece', price: 270 },
  'Bortshaiba_65': { pricingType: 'per_piece', price: 340 },
  'Bortshaiba_80': { pricingType: 'per_piece', price: 390 },
  'Bortshaiba_100': { pricingType: 'per_piece', price: 400 },
  'Bortshaiba_125': { pricingType: 'per_piece', price: 428 },
  'Bortshaiba_150': { pricingType: 'per_piece', price: 650 },
  'Bortshaiba_200': { pricingType: 'per_piece', price: 1400 },
  'Bortshaiba_250': { pricingType: 'per_piece', price: 1800 },
  'Bortshaiba_300': { pricingType: 'per_piece', price: 2065 },
  'Bortshaiba_350': { pricingType: 'per_piece', price: 2750 },

  // Отводы (за шт)
  'Otvod_20': { pricingType: 'per_piece', price: 235 },
  'Otvod_25': { pricingType: 'per_piece', price: 240 },
  'Otvod_25_32mm': { pricingType: 'per_piece', price: 240 },
  'Otvod_32': { pricingType: 'per_piece', price: 300 },
  'Otvod_40': { pricingType: 'per_piece', price: 350 },
  'Otvod_50': { pricingType: 'per_piece', price: 500 },
  'Otvod_65': { pricingType: 'per_piece', price: 1000 },
  'Otvod_80': { pricingType: 'per_piece', price: 1150 },
  'Otvod_100': { pricingType: 'per_piece', price: 1700 },
  'Otvod_125': { pricingType: 'per_piece', price: 2600 },
  'Otvod_150': { pricingType: 'per_piece', price: 6130 },

  // Накидные гайки (за шт)
  'Nak_Gaika_1': { pricingType: 'per_piece', price: 175 },
  'Nak_Gaika_1_1.4': { pricingType: 'per_piece', price: 175 },
  'Nak_Gaika_1_1.2': { pricingType: 'per_piece', price: 175 },
  'Nak_Gaika_2': { pricingType: 'per_piece', price: 300 },

  // Шайбы накидных гаек (за шт)
  'Shaib_Gaika_1': { pricingType: 'per_piece', price: 65 },
  'Shaib_Gaika_1_1.4': { pricingType: 'per_piece', price: 70 },
  'Shaib_Gaika_1_1.2': { pricingType: 'per_piece', price: 80 },
  'Shaib_Gaika_2': { pricingType: 'per_piece', price: 90 },

  // Шайбы с наружной резьбой (за шт)
  'Shaib_Nar_Rezba_1': { pricingType: 'per_piece', price: 220 },
  'Shaib_Nar_Rezba_1_1.4': { pricingType: 'per_piece', price: 220 },
  'Shaib_Nar_Rezba_1_1.2': { pricingType: 'per_piece', price: 221 },
  'Shaib_Nar_Rezba_2': { pricingType: 'per_piece', price: 300 },
};

export default DEFAULT_FITTING_PRICES;

